import { ComponentProps } from "react";

export const ErrorImage = (props: ComponentProps<"svg">) => (
  <svg width={154} height={112} fill="none" {...props}>
    <ellipse cx={77} cy={107.5} rx={77} ry={4.5} fill="#EEE" />
    <path
      opacity={0.5}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M66.645 89h18.71c.356 0 .645.672.645 1.5s-.289 1.5-.645 1.5h-18.71c-.356 0-.645-.672-.645-1.5s.289-1.5.645-1.5zM70.42 94h12.16c.232 0 .42.672.42 1.5s-.188 1.5-.42 1.5H70.42c-.232 0-.42-.672-.42-1.5s.188-1.5.42-1.5z"
      fill="#2D80AF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51 80.601V26.502C51.126 24.167 52.316 23 54.57 23h40.085L104 34.676v45.925l-5.472-1.919L94.655 82l-3.871-3.318L85.848 82l-3.57-3.318L77.5 82l-4.395-3.318L69.99 82l-4.886-3.318L60.596 82l-3.862-3.318L51 80.602z"
      fill="#fff"
      stroke="#2D80AF"
      strokeWidth={3}
    />
    <path stroke="#2D80AF" strokeWidth={3} d="M93.5 23v13.882M94 35.382h10" />
    <circle
      cx={84.5}
      cy={46.5}
      r={2.5}
      fill="#fff"
      stroke="#2D80AF"
      strokeWidth={2}
    />
    <rect
      x={71}
      y={52}
      width={11}
      height={6}
      rx={3}
      fill="#fff"
      stroke="#2D80AF"
      strokeWidth={2}
    />
    <circle
      cx={68.5}
      cy={46.5}
      r={2.5}
      fill="#fff"
      stroke="#2D80AF"
      strokeWidth={2}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.667 34.123c8.281-1.217 14.639-8.351 14.639-16.97C47.306 7.68 39.626 0 30.153 0 20.68 0 13 7.68 13 17.153a17.11 17.11 0 005.687 12.758c2.287 2.53 8.407 8.323 17.063 9.089 0 0-2.07-.615-3.068-4.818l-.015-.06z"
      fill="#96BFD7"
    />
    <path
      d="M31.35 17.5l5.267-5.266a1.309 1.309 0 00-1.85-1.85L29.5 15.648l-5.266-5.266a1.31 1.31 0 00-1.85 1.85l5.265 5.267-5.266 5.266a1.309 1.309 0 001.85 1.85L29.5 19.35l5.266 5.266a1.304 1.304 0 001.85 0c.512-.51.512-1.34 0-1.85L31.352 17.5z"
      fill="#fff"
    />
  </svg>
);
